<template>
  <div class="container">
    <h2 class="text-black font-semibold text-2xl py-8 text-center">Plätze auswählen</h2>
    <div class="border rounded-xl overflow-hidden">
      <div class="w-full" style="height: 500px" id="chart"></div>
    </div>
  </div>
</template>


<script>
import _map from 'lodash/map';
import _find from 'lodash/find';

export default {
  props: {
    pricing: Object,
    event: Object,
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.getSeatsio().then(() => this.renderChart());
  },
  beforeDestroy() {
    this.destroyChart();
  },
  computed: {
    formatedPricing() {
      return _map(this.pricing.categories, (category) => {
        return {
          category: category.seats_io_category_id,
          ticketTypes: _map(category.types, (type) => {
            return {
              ticketType: type.id.toString(),
              price: type.price_including_fees,
              label: type.title,
              description: type.description ? type.description : '',
            };
          }),
        };
      });
    },
  },
  methods: {
    updated() {
      this.chart.listSelectedObjects((objects) => {
        let formatedObjects = _map(objects, (object) => {
          let price = _find(object.pricing.ticketTypes, {
            ticketType: object.selectedTicketType,
          }).price;

          return {
            type_id: +object.selectedTicketType,
            price: price,
            seat_id: object.id,
            hold_token: this.chart.holdToken,
          };
        });

        this.$emit('updated', formatedObjects);
      });
    },
    renderChart() {
      const seatingIds = this.event.reserved_seating.seating_id.split(',');

      this.chart = new seatsio.SeatingChart({
        ...(seatingIds.length > 1 ? { event: seatingIds[0] } : { events: seatingIds }),
        divId: 'chart',
        workspaceKey: this.event.reserved_seating.workspace_key,
        language: 'de',
        showFullScreenButton: false,
        selectionValidators: [{ type: 'noOrphanSeats', mode: 'lenient' }],
        pricing: this.formatedPricing,
        priceFormatter: this.formatPrice,
        onObjectSelected: this.updated,
        onObjectDeselected: this.updated,
        onSelectionValid: this.onSelectionValid,
        onSelectionInvalid: this.onSelectionInvalid,
        showSectionContents: 'onlyAfterZoom',
        session: 'continue',
        showLegend: true,
        objectWithoutCategorySelectable: false,
        objectWithoutPricingSelectable: false,
        multiSelectEnabled: true,
      }).render();
    },
    formatPrice(value) {
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

      return formatter.format(value / 100);
    },
    getSeatsio() {
      return typeof seatsio !== 'undefined' ? Promise.resolve(seatsio) : this.loadSeatsio();
    },
    loadSeatsio() {
      return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.onload = () => resolve(seatsio);
        script.onerror = () => reject(`Could not load ${script.src}`);
        script.src = 'https://cdn-eu.seatsio.net/chart.js';
        document.head.appendChild(script);
      });
    },
    destroyChart() {
      if (this.chart && this.chart.state !== 'DESTROYED') {
        this.chart.destroy();
      }
    },
    onSelectionValid() {
      this.$emit('selectionValidity', true);
    },
    onSelectionInvalid() {
      this.$emit('selectionValidity', false);
    },
  },
};
</script>